<template>
  <p class="text-sm text-center text-secondary-500 dark:text-darkblue-200">&copy;{{ currYear }} ZeroComa - {{ version }}</p>
</template>

<script>
export default {
  name: 'copy',
  data: function () {
    return {
      currYear: '...',
      version: process.env.VUE_APP_VERSION
    }
  },
  created: function () {
    this.setDate()
  },
  methods: {
    setDate: function () {
      const date = new Date()
      this.currYear = date.getFullYear()
    }
  }
}
</script>
